import axios from "axios";
import { WorkspaceApiResult } from "./connection";

const baseUrl = "/api/v0/requests";

export interface ReportRequest {
    id?: string;
    name: string;
    connectionId: string;
    recentExportStartDate: string | null;
    recentExportEndDate: string | null;
    workspaceId: string;
}

export interface CreateReportRequestModel {
    name: string;
    workspaceId: string;
    connectionId: string;
}

export interface RequestApi {
    getRequests: () => Promise<ReportRequest[]>;
    getRequest: (requestId: string) => Promise<ReportRequest>;
    createRequest: (model: CreateReportRequestModel) => Promise<string>;
    updateRequest: (requestId: string, model: CreateReportRequestModel) => Promise<void>;
    deleteRequest: (requestId: string) => Promise<void>;
    getWorkspaces: (requestId: string) => Promise<WorkspaceApiResult[]>;
    getUnmapped: (requestId: string, start: string, end: string) => Promise<ExportMappingGaps>;
}

export interface ExportGapItem {
    id: string;
    name: string;
}

export interface ExportMappingGaps {
    requestName: string;
    unmappedEmployees: ExportGapItem[];
    unmappedClients: ExportGapItem[];
    excludedEmployees: ExportGapItem[];
}

const requestApi: RequestApi = {
    getRequests: async () => {
        const { data } = await axios.get<ReportRequest[]>(`${baseUrl}`);
        return data;
    },

    getRequest: async (requestId: string) => {
        const { data } = await axios.get<ReportRequest>(`${baseUrl}/${requestId}`);
        return data;
    },

    createRequest: async (model: CreateReportRequestModel) => {
        const { data } = await axios.post<string>(`${baseUrl}`, model);
        return data;
    },

    updateRequest: async (requestId: string, model: CreateReportRequestModel) => await axios.patch(`${baseUrl}/${requestId}`, model),

    deleteRequest: async (requestId: string) => await axios.delete(`${baseUrl}/${requestId}`),

    getWorkspaces: async (requestId: string) => {
        const { data } = await axios.get<WorkspaceApiResult[]>(`${baseUrl}/${requestId}/workspaces`);
        return data;
    },
    getUnmapped: async (requestId: string, start: string, end: string) => {
        const { data } = await axios.get<ExportMappingGaps>(`${baseUrl}/${requestId}/unmapped`, { params: { start, end } });
        return data;
    },
}

export default requestApi;